export default "__VITE_ASSET__B8bxB97f__"